<template>
    <div>
        <v-navigation-drawer v-model="sidebar" style="z-index:9999999"
                             fixed
                             bottom
                             temporary>
            <v-list nav dense>
                <v-list-item-group active-class="deep-purple--text text--accent-4">
                    <v-list-item>
                        <v-list-item-title @click="$vuetify.goTo('#introduction')">معرفی</v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title @click="$vuetify.goTo('#advantages')">مزیت ها</v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title @click="$vuetify.goTo('#specialFacilities')">امکانات ویژه</v-list-item-title>
                    </v-list-item> 
                    <v-list-item>
                        <v-list-item-title @click="$vuetify.goTo('#specialOffer')">پیشنهاد ویژه</v-list-item-title>
                    </v-list-item> 
                    <v-list-item>
                        <v-list-item-title @click="$vuetify.goTo('#downloadApplication')">دانلود نرم افزار</v-list-item-title>                       
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title @click="$vuetify.goTo('#preview')">پیش نمایش</v-list-item-title>                       
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
        <v-card class="" style="background-color:#00008B">
            <v-app-bar fixed style="background-color:#00008B;z-index:9999"
                       color="#00008B"
                       dark
                       inverted-scroll>
                <span class="hidden-sm-and-up">
                    <v-app-bar-nav-icon class="mr-n5" @click.stop="sidebar = !sidebar"></v-app-bar-nav-icon>
                </span>
                <!--<v-app-bar-nav-icon></v-app-bar-nav-icon>-->
                <v-img :src="getLogo" max-height="55" max-width="45" class="mr-0 mr-xl-8 mr-lg-8 mr-md-8 mr-sm-2" alt="آساسرویس"></v-img>
                <h2 class="mr-1 mr-xl-2 mr-lg-2 mr-md-2 mr-sm-2 my-xs-2 my-sm-2 my-md-0 my-lg-0 my-xl-0 asaservicetext">آسا سرویس</h2>
                <v-spacer></v-spacer>
                <h6 class="ml-6 hidden-xs-only" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px;cursor:pointer" @click="$vuetify.goTo('#introduction')">معرفی</h6>
                <h6 class="ml-6 hidden-xs-only" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px;cursor:pointer" @click="$vuetify.goTo('#advantages')">مزیت ها</h6>
                <h6 class="ml-6 hidden-xs-only" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px;cursor:pointer" @click="$vuetify.goTo('#specialFacilities')">امکانات ویژه</h6>
                <h6 class="ml-6 hidden-xs-only" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px;cursor:pointer" @click="$vuetify.goTo('#specialOffer')">پیشنهاد ویژه</h6>
                <h6 class="ml-6 hidden-xs-only" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px;cursor:pointer" @click="$vuetify.goTo('#downloadApplication')">دانلود نرم افزار</h6>
                <h6 class="ml-6 hidden-xs-only" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px;cursor:pointer" @click="$vuetify.goTo('#preview')">پیش نمایش</h6>
                <v-btn elevation="16" style="font-family: 'Yekan-Bakh-Regular';font-size:15px;font-weight:bold "
                       rounded class="mr-8 mr-xl-16 mr-lg-16 mr-md-16 mr-sm-1 ml-16 mt-n2 btnanimation" @click="openAsaService()"
                       text v-ripple="{ class: 'primary--text' }">ورود به سامانه</v-btn>
                <!--<v-btn icon>
                <v-icon>mdi-magnify</v-icon>
            </v-btn>

            <v-btn icon>
                <v-icon>mdi-heart</v-icon>
            </v-btn>

            <v-btn icon>
                <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>-->
            </v-app-bar>
        </v-card>
        <v-btn v-scroll="onScroll" class="floatingAnimation" id="floatbtn"
               v-show="fab"
               fab
               dark
               fixed
               bottom
               right
               color="primary"
               @click="toTop">
            <v-icon>mdi-chevron-up </v-icon>
        </v-btn>
        <div class="px-0 mx-0 " cols="12" style="background-color:darkblue;border-bottom-right-radius:650px">
            <v-row no-gutters></v-row>
            <v-row class="mt-6" no-gutters>
                <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="mr-2 mr-xl-16 mr-lg-16 mr-md-16 mr-sm-16">
                    <v-row no-gutters>
                        <v-img :src="getLogo" max-height="65" max-width="50" class="mt-8" alt="آساسرویس"></v-img>
                        <h2 class="mt-9 mr-1  mr-xl-2 mr-lg-2 mr-md-2 mr-sm-2" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:25px">آسا سرویس</h2>
                        <v-btn elevation="16" style="font-family: 'Yekan-Bakh-Regular';font-size:15px;font-weight:bold "
                               rounded class="mr-8 mt-9 btnanimation hidden-md-and-up" @click="openAsaService()"
                               text v-ripple="{ class: 'primary--text' }">ورود به سامانه</v-btn>
                    </v-row>
                </v-col>
                <v-col class="mr-16">
                    <v-row class="mt-10 mr-16" no-gutters>
                        <h6 class="ml-6 hidden-xs-only" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px;cursor:pointer" @click="$vuetify.goTo('#introduction')">معرفی</h6>
                        <h6 class="ml-6 hidden-xs-only" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px;cursor:pointer" @click="$vuetify.goTo('#advantages')">مزیت ها</h6>
                        <h6 class="ml-6 hidden-xs-only" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px;cursor:pointer" @click="$vuetify.goTo('#specialFacilities')">امکانات ویژه</h6>
                        <h6 class="ml-6  hidden-xs-only" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px;cursor:pointer" @click="$vuetify.goTo('#specialOffer')">پیشنهاد ویژه</h6>
                        <h6 class="ml-6 hidden-xs-only" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px;cursor:pointer" @click="$vuetify.goTo('#downloadApplication')">دانلود نرم افزار</h6>
                        <h6 class="ml-6 hidden-xs-only" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:15px;cursor:pointer" @click="$vuetify.goTo('#map')">پیش نمایش</h6>
                        <v-btn elevation="16" style="font-family: 'Yekan-Bakh-Regular';font-size:15px;font-weight:bold "
                               rounded class="mr-16 mt-n2 btnanimation  hidden-xs-only hidden-sm-only" @click="openAsaService()"
                               text v-ripple="{ class: 'primary--text' }">ورود به سامانه</v-btn>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters class=" mt-xl-16 mt-lg-16 mt-md-16 mt-sm-16">
                <v-col cols="1"></v-col>
                <v-col class="mt-2 mt-xl-16 mt-lg-16 mt-md-16 mt-sm-16 mr-n2">
                    <h1 style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:35px" class="hidden-xs-only"> آسا سرویس</h1>
                    <h2 class="mt-8" style="color: white; font-family: 'Yekan-Bakh-Regular';font-size:28px">اپلیکیشن <span style="color:#FFDE03">جامع</span> مدیریت مراکز تعویض روغن</h2>
                    <br />
                    <v-btn elevation="4" class="maindownloadbtn"
                           outlined
                           dark
                           x-large
                           rounded @click="$vuetify.goTo('#downloadApplication')">دانلود اپلیکیشن</v-btn>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="mt-16 d-flex child-flex">
                    <v-row no-gutters class="">
                        <v-col cols="6">
                            <v-img :src="phone" max-height="630" max-width="390" Contain class="ml-n10 myanimation" alt="نرم افزار آسا"></v-img>
                        </v-col>
                        <v-col cols="6">
                            <v-img :src="phone2" max-height="630" max-width="390" Contain class="ml-n10 myanimation" alt="نرم افزار آسا"></v-img>
                        </v-col>


                    </v-row>
                </v-col>
            </v-row>
        </div>
        <v-row no-gutters class="mt-4 mt-xl-16 mt-lg-16 mrt-md-16 mt-sm-16" id="introduction">
            <v-spacer></v-spacer>
            <v-col cols="12" class="hidden-sm-and-up"> <h1 style="font-size:20px; font-family: 'Yekan-Bakh-Regular';text-align:justify" class="mt-16 mr-3">معرفی آساسرویس به زبان ساده</h1></v-col>
            <v-col cols="12" sm="12" md="5" lg="5" xl="5" class="hidden-sm-and-up" :style="{ 'background-image': 'url(' + background1 + ')' }">
                <br />
                <br />
                <br />
                <br />
                <br />
                <v-row no-gutters class="mt-16">
                    <v-col cols="6" xs="12" sm="12" md="6" lg="6" xl="6" class="ml-n10 mr-5" style="z-index:99">
                        <v-card elevatable="24" data-aos="slide-left" data-aos-duration="2000" data-aos-delay="500">
                            <v-img :src="dash1" max-height="650" max-width="330"  alt="نرم افزار تعویض روغن"></v-img>
                        </v-card>
                    </v-col>
                    <v-col cols="5" xs="12" sm="12" md="5" lg="5" xl="5" class="mr-n10 mt-13" style="z-index:9">
                        <v-card elevatable="10" data-aos="slide-left" data-aos-duration="2000" data-aos-delay="1000">
                            <v-img :src="dash2" max-height="450" max-width="280" alt="نرم افزار تعویض روغن"></v-img>
                        </v-card>
                    </v-col>
                </v-row>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="mt-16">
                <h1 style="font-size:40px; font-family: 'Yekan-Bakh-Regular';text-align:justify" class="mt-16 hidden-xs-only">معرفی آساسرویس به زبان ساده</h1>
                <h4 style="font-size:15px; font-family: 'Yekan-Bakh-Regular';color:#7B7B7B;text-align:justify" class="mt-0 mt-xl-10 mt-lg-10 mt-md-10 mt-sm-10 mx-2 mx-xl-0 mx-lg-0 mx-md-0 mx-sm-0">تمامی صاحبان کسب و کار در هر شغلی به دنبال جذب مشتری بیشتر و قوی تر کردن کسب و کار خود هستند. با توجه به رقابت موجود در بازار برای افزایش درآمد و سود دهی بیشتر نیاز به یک مدیریت قوی جهت ارائه خدمات با کیفیت بالاتر، ارتباط بهتر با مشتریان، ارائه خدمات جدید و خلاقانه، تخفیفات مناسب،استفاده از تکنولوژی های نوین و زیرساخت های موجود عمومی به شدت احساس می شود. </h4>
                <h4 style="font-size:15px; font-family: 'Yekan-Bakh-Regular';color:#7B7B7B;text-align:justify" class="mt-2 mt-xl-10 mt-lg-10 mt-md-10 mt-sm-10 mx-2 mx-xl-0 mx-lg-0 mx-md-0 mx-sm-0">آسا سرویس یک سامانه هوشمند تخصصی مبتنی بر تلفن همراه می باشد که جهت مدیریت و نظارت بر کلیه فرآیندها در اتوسرویس ها و مراکز تعویض روغن توسط کارشناسان مجرب شرکت آسمان کارمانیا نیازسنجی، طراحی،تولید و به بهره برداری رسیده است. در این سامانه صاحبان این نوع مشاغل از طریق تلفن همراه خود فرآیندهای مربوط به امور مشتریان،امور مالی و انبارداری کسب و کار خود را مدیریت و کنترل می نمایند.</h4>
                <!-- <v-btn elevation="2" class="mt-10 btnanimation"
                    large
                    outlined
                    rounded>
                 ادامه مطلب
                 <v-icon dark class="btnanimationicon"
                         right>
                     mdi-chevron-left
                 </v-icon>
             </v-btn>-->
            </v-col>
            <v-col cols="0" sm="0" md="1" lg="1" xl="1"></v-col>
            <v-col cols="12" sm="12" md="5" lg="5" xl="5" class="hidden-xs-only" :style="{ 'background-image': 'url(' + background1 + ')' }" v-tilt="{speed: 500, perspective: 1200}">
                <br />
                <br />
                <br />
                <br />
                <br />
                <v-row no-gutters>
                    <v-col cols="6" xs="12" sm="12" md="6" lg="6" xl="6" class="ml-n10" style="z-index:99">
                        <v-card elevatable="24" data-aos="slide-left" data-aos-duration="2000" data-aos-delay="500">
                            <v-img :src="dash1" max-height="650" max-width="330" alt="نرم افزار تعویض روغن اندروید"></v-img>
                        </v-card>
                    </v-col>
                    <v-col cols="5" xs="12" sm="12" md="5" lg="5" xl="5" class="mr-n10 mt-13" style="z-index:9">
                        <v-card elevatable="10" data-aos="slide-left" data-aos-duration="2000" data-aos-delay="1000">
                            <v-img :src="dash2" max-height="450" max-width="280" alt="نرم افزار تعویض روغن اندروید"></v-img>
                        </v-card>
                    </v-col>
                </v-row>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
            </v-col>
        </v-row>
        <br />
        <br />
        <v-row class="mx-4 mt-16">
            <v-spacer></v-spacer>
            <v-col cols="3">
                <v-img :src="phone11" max-height="880" max-width="500" class="" style="z-index:9" v-tilt="{speed: 500, perspective: 1200}"  alt="اپلیکیشن تعویض روغن"></v-img>
            </v-col>
            <v-col cols="9">
                <v-card class="mr-n16" v-tilt="{speed: 500, perspective: 1200}">
                    <v-img :src="dashlaptop"  alt="اپلیکیشن تعویض روغن"></v-img>
                </v-card>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
        <v-row no-gutters class="mt-16" id="advantages">
            <v-col cols="0" sm="0" md="1" lg="1" xl="1"></v-col>
            <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <v-img :src="phone1" max-height="680" max-width="300" Contain class="myanimation mr-6 mr-xl-16 mr-lg-16 mr-md-16 mr-sm-16"  alt="اپلیکیشن تعویض روغن اندروید"></v-img>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="mt-16">
                <v-row class="mt-6">
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                        <v-hover v-slot="{ hover }"
                                 open-delay="200">
                            <v-card shaped :elevation="hover ? 16 : 2" class="cardanimation">
                                <v-btn elevation="2" class="mt-n6 mr-10 cardbtn" style="background-image: -webkit-linear-gradient( -45deg,#092ef1 0%,#010570 100%);color:white"
                                       fab>
                                    01
                                </v-btn>
                                <v-card-title class="mt-6" style="font-weight:bold">
                                    طراحی حرفه ای
                                </v-card-title>
                                <v-card-text style="font-size:15px; font-family: 'Yekan-Bakh-Regular'" class="mt-4 cardtext">
                                    طراحی تخصصی و انحصاری مخصوص اتوسرویس ها و مراکز تعویض روغن
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="mt-3 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-0">
                        <v-hover v-slot="{ hover }"
                                 open-delay="200">
                            <v-card shaped :elevation="hover ? 16 : 2" class="cardanimation">
                                <v-btn elevation="2" class="mt-n6 mr-10 cardbtn" style="background-image: -webkit-linear-gradient(-45deg,#fab000 0%,#cd8400 100%);color:white"
                                       fab>
                                    02
                                </v-btn>
                                <v-card-title class="mt-6" style="font-weight:bold">
                                    مبتنی بر موبایل
                                </v-card-title>
                                <v-card-text style="font-size:15px; font-family: 'Yekan-Bakh-Regular'" class="mt-4 cardtext">
                                    مبتنی بر موبایل بدون نیاز به هیچ گونه تجهیزات و زیرساخت های جانبی
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="mt-3">
                        <v-hover v-slot="{ hover }"
                                 open-delay="200">
                            <v-card shaped :elevation="hover ? 16 : 2" class="cardanimation">
                                <v-btn elevation="2" class="mt-n6 mr-10 cardbtn" style="background-image: -webkit-linear-gradient(-45deg,#9ff300 0%,#1a8300 100%);color:white"
                                       fab>
                                    03
                                </v-btn>
                                <v-card-title class="mt-6" style="font-weight:bold">
                                    سامانه پیامکی
                                </v-card-title>
                                <v-card-text style="font-size:15px; font-family: 'Yekan-Bakh-Regular'" class="mt-4 cardtext">
                                    بهره برداری از سامانه پیامکی هوشمند سیستمی ارتباط با مشتریان
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="mt-3">
                        <v-hover v-slot="{ hover }"
                                 open-delay="200">
                            <v-card shaped :elevation="hover ? 16 : 2" class="cardanimation">
                                <v-btn elevation="2" class="mt-n6 mr-10 cardbtn" style="background-image: -webkit-linear-gradient( -45deg,#BA5B12 0%,#1a8300 100%);color:white"
                                       fab>
                                    04
                                </v-btn>
                                <v-card-title class="mt-6" style="font-weight:bold">
                                    شناسنامه مشتریان
                                </v-card-title>
                                <v-card-text style="font-size:15px; font-family: 'Yekan-Bakh-Regular';" class="mt-4 cardtext">
                                    دسترسی سریع به سوابق سرویس های قبل مشتریان براساس خودرو،مشتری و شماره تلفن همراه
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="0" sm="0" md="1" lg="1" xl="1"></v-col>
        </v-row>
        <v-row id="specialFacilities">
            <v-col cols="0" sm="0" md="0" lg="0" xl="0"></v-col>
            <v-col cols="12" class="hidden-sm-and-up">
                <v-row no-gutters class="mr-16">
                    <v-col cols="6" class="ml-n10 mt-13" style="z-index:9">
                        <v-card elevatable="10" data-aos="slide-left" data-aos-duration="2000" data-aos-delay="1000">
                            <v-img :src="dash4" max-height="450" max-width="280" alt="نرم افزار تعویض روغن اندروید"></v-img>
                        </v-card>
                    </v-col>
                    <v-col cols="6" class="mr-n10" style="z-index:99">
                        <v-card elevatable="24" data-aos="slide-left" data-aos-duration="2000" data-aos-delay="500">
                            <v-img :src="dash3" max-height="650" max-width="330" alt="نرم افزار تعویض روغن اندروید"></v-img>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="5" lg="5" xl="5" class="mt-16 mr-1 mr-sm-1 mr-md-6 mr-lg-6 mr-xl-6 ml-1 ml-sm-1 ml-md-0 ml-lg-0 ml-xl-0">
                <!--1111-->
                <v-expansion-panels class="dropdownback mt-16" v-model="exp">
                    <v-expansion-panel class="test" id="expan" @click="expanClick()">
                        <v-expansion-panel-header expand-icon="" style="color:#8B8B99;font-size:20px; font-family: 'Yekan-Bakh-Regular';" class="py-6" id="expheader">
                            <div>
                                <v-icon large right class="px-0" color="#7DDDE9" id="expheadericon">mdi-account-group-outline</v-icon>
                                <span style="letter-spacing:1px" class="mt-2 mr-6">چند کاربره</span>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content id="ex" style="color:white" class="mr-16">
                            در سامانه آساسرویس هر مرکز اتوسرویس می تواند از چندین کاربر با سطح دسترسی های متفاوت برای مدیریت سامانه استفاده کند.
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <!--222222-->
                <v-expansion-panels class="mt-6 dropdownback" v-model="exp2">
                    <v-expansion-panel class="test" id="expan2" @click="expan2Click()">
                        <v-expansion-panel-header expand-icon="" style="color:#8B8B99;font-size:20px; font-family: 'Yekan-Bakh-Regular';" class="py-6" id="expheader2">
                            <div>
                                <v-icon large right class="px-0" color="#7DDDE9" id="expheadericon2">mdi-face-agent </v-icon>
                                <span style="letter-spacing:1px" class="mt-2 mr-6">پشتیبانی کامل</span>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content style="color:white" class="mr-16">
                            سامانه آساسرویس دارای پشتیبانی 7/24 می باشد. که مراکز می توانند با شماره 09364444263 تماس گرفته و از خدمات پشتیبانی سامانه بهره ببرند.
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <!--33333-->
                <v-expansion-panels class="mt-6 dropdownback" v-model="exp3">
                    <v-expansion-panel id="expan3" @click="expan3Click()">
                        <v-expansion-panel-header expand-icon="" style="color:#8B8B99;font-size:20px; font-family: 'Yekan-Bakh-Regular';" class="py-6" id="expheader3">
                            <div>
                                <v-icon large right class="px-0" color="#7DDDE9" id="expheadericon3">mdi-file-chart </v-icon>
                                <span style="letter-spacing:1px" class="mt-2 mr-6">گزارشات متنوع</span>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content style="color:white" class="mr-16">
                            در سامانه آسا سرویس به جهت اطلاع صاحبان کسب وکار از وضعیت عملکرد مجموعه تحت نظر گزارشات متنوع آماری طراحی و در اختیار عزیزان قرار داده شده است.
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <!--44444-->
                <v-expansion-panels class="mt-6 dropdownback" v-model="exp4">
                    <v-expansion-panel id="expan4" @click="expan4Click()">
                        <v-expansion-panel-header expand-icon="" style="color:#8B8B99;font-size:20px; font-family: 'Yekan-Bakh-Regular';" class="py-6" id="expheader4">
                            <div>
                                <v-icon large right class="px-0" color="#7DDDE9" id="expheadericon4">mdi-store </v-icon>
                                <span style="letter-spacing:1px" class="mt-2 mr-6">انبار داری</span>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content style="color:white;text-align:justify" class="mr-16">
                            در سامانه تمامی محصولات موجودی فروشگاه با اطلاعاتی از قبیل نام محصول،دسته بندی محصول،کیلومتر موثر و نقطه سفارش هر کالا ثبت میگردد و در هر لحظه امکان ویرایش اطلاعات مربوط به هر محصول وجود دارد.
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
            <v-col cols="6" class="hidden-xs-only mr-16 mt-16 pr-16" :style="{ 'background-image': 'url(' + background2 + ')' }" v-tilt="{speed: 500, perspective: 1200}">
                <v-row no-gutters class="mr-16">
                    <v-col cols="6" class="ml-n10 mt-13" style="z-index:9">
                        <v-card elevatable="10" data-aos="slide-left" data-aos-duration="2000" data-aos-delay="1000">
                            <v-img :src="dash4" max-height="450" max-width="280"  alt="اپلیکیشن تعویض روغن اندروید"></v-img>
                        </v-card>
                    </v-col>
                    <v-col cols="6" class="mr-n10" style="z-index:99">
                        <v-card elevatable="24" data-aos="slide-left" data-aos-duration="2000" data-aos-delay="500">
                            <v-img :src="dash3" max-height="650" max-width="330" alt="اپلیکیشن تعویض روغن اندروید"></v-img>
                        </v-card>
                    </v-col>
                </v-row>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
        <v-row class="mt-16 mb-10 mx-5" style="background-color:white;border-top-right-radius:500px;border-top-left-radius:500px;border-bottom-left-radius:500px;border-bottom-right-radius:500px" id="specialOffer">
            <v-spacer></v-spacer>
            <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="mt-8">
                <v-hover v-slot="{ hover }"
                         open-delay="100">
                    <v-card style="border:thin" flat :elevation="hover ? 4 : 0" class="pricecard">
                        <v-card-title class="d-flex justify-center">
                            نرم افزار کاملا رایگان
                        </v-card-title>
                        <v-card-text class="d-flex justify-center">
                            <div class="price_icon pricecardicon">
                                <v-img :src="price2" contain max-height="150" max-width="250" class="mt-6" alt="تعویض روغنی"></v-img>
                            </div>
                        </v-card-text>
                        <v-card-text class="mt-3 pb-6">
                            <h5 style="text-align: justify">پس از گذشت دوره تست و در صورت تمایل به بهره برداری از سامانه،نرم افزار آسا سرویس بصورت کاملا رایگان در اختیار مشتریان قرار خواهد گرفت.هزینه های بهره برداری طی قراردادی با توافق طرفین براساس مبلغی اندک به ازای هر سرویس ثبت شده در سامانه محاسبه و اخذ (به وسیله خود سامانه) می گردد</h5>
                        </v-card-text>
                        <br />
                    </v-card>
                </v-hover>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="mt-8">
                <v-hover v-slot="{ hover }"
                         open-delay="100">
                    <v-card style="border:solid;border-color:#FCFCFF" flat :elevation="hover ? 4 : 0" class="pricecard">
                        <v-card-title class="d-flex justify-center">
                            دوره تست رایگان بهره برداری
                        </v-card-title>
                        <v-card-text class="d-flex justify-center">
                            <div class="price_icon pricecardicon">
                                <v-img :src="price1" contain max-height="150" max-width="250" class="mt-6" alt="تعویض روغنی"></v-img>
                            </div>
                        </v-card-text>
                        <v-card-text class="mt-3">
                            <h5 style="text-align: justify">با توجه به مزایای ویژه و انحصاری این سامانه و همچنین جهت آشنایی صاحبان کسب و کار با سامانه آسا سرویس،این مجموعه به مدت 20 روز(قابل تمدید) بهره برداری کامل از امکانات سامانه را در قالب دوره تست بصورت رایگان در اختیار مشتریان قرار خواهد داد و در پایان دوره در صورت رضایت از امکانات و تمایل به بهره برداری قرارداد همکاری منعقد میگردد</h5>
                        </v-card-text>
                    </v-card>
                </v-hover>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
        <v-row class="mt-16" no-gutters style="background-color:darkblue;" id="downloadApplication">
            <v-col cols="0" sm="0" md="1" lg="1" xl="1"></v-col>
            <v-col cols="12" class="hidden-sm-and-up">
                <v-row>
                    <v-col cols="6"><h1 style="color:white;font-size:30px" class="mt-16 pr-3">دریافت اپلیکیشن آساسرویس</h1></v-col>
                    <v-col cols="6">
                        <v-row class="mt-10 pl-3">
                            <v-col cols="6"> <v-img :src="phone1" max-height="650" max-width="280" class="myanimation" alt="اپلیکیشن آسا"></v-img></v-col>
                            <v-col cols="6"><v-img :src="phone1" max-height="650" max-width="280" class="myanimation" alt="اپلیکیشن آسا"></v-img></v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="mt-16">
                <v-row>
                    <h1 style="color:white;font-size:30px" class="mt-16 hidden-xs-only">دریافت اپلیکیشن آساسرویس</h1>
                </v-row>
                <v-row>
                    <h6 style="color:white;font-size:15px" class="mt-16 pl-3 pl-sm-3 pl-md-0 pl-lg-0 pl-xl-0 pr-4 pr-sm-4 pr-md-0 pr-lg-0 pr-xl-0">آساسرویس، طراحی شده براساس <span style="color:#FFDE03">نیاز</span> مراکز تعویض روغن و برای مدیریت <span style="color:#FFDE03">جامع</span> فرآیندهای مراکز تعویض روغن</h6>
                </v-row>
                <v-row class="mt-16  pr-5 pr-sm-5 pr-md-0 pr-lg-0 pr-xl-0">
                    <a href="https://pwapanel.asaserviceapp.com" style="text-decoration:none">
                        <v-btn elevation="2" style="font-weight:bold" class="downloadbtn"
                               outlined @click="appStore()"
                               x-large><v-icon right large class="pl-8">mdi-apple</v-icon>نسخه IOS</v-btn>
                    </a>
                </v-row>
                <v-row class="mt-10 pr-5 pr-sm-5 pr-md-0 pr-lg-0 pr-xl-0">
                    <a href="./asaservice.apk" download style="text-decoration:none">
                        <v-btn elevation="2" style="font-weight:bold" class="downloadbtn pl-2 pr-4"
                               outlined
                               x-large>
                            <v-icon right large class="pl-8 ">mdi-android </v-icon>نسخه اندروید
                        </v-btn>
                    </a>
                </v-row>
                <v-row class="mt-10 pr-5 pr-sm-5 pr-md-0 pr-lg-0 pr-xl-0">
                    <a href="https://asaapp.asaserviceapp.com/" style="text-decoration:none">
                        <v-btn elevation="2" style="font-weight:bold" class="downloadbtn pl-10 pr-4"
                               outlined
                               x-large>
                            <v-icon right large class="pl-8">mdi-application</v-icon>نسخه وب
                        </v-btn>
                    </a>
                </v-row>
                <v-row class="mt-10 pr-5 pr-sm-5 pr-md-0 pr-lg-0 pr-xl-0">
                    <a href="./asaservice.pdf" style="text-decoration:none">
                        <v-btn elevation="2" style="font-weight:bold" class="downloadbtn pr-4 pl-3"
                               outlined
                               x-large>
                            <v-icon right large class="pl-8">mdi-file-pdf</v-icon>راهنما سامانه
                        </v-btn>
                    </a>
                </v-row>
                <v-row class="mt-10 pr-5 pr-sm-5 pr-md-0 pr-lg-0 pr-xl-0 mb-0 mb-sm-0 mb-md-8 mb-lg-8 mb-xl-8 ">
                    <a href="./form.pdf" style="text-decoration:none">
                        <v-btn elevation="2" style="font-weight:bold" class="downloadbtn pr-4 pl-6"
                               outlined
                               x-large>
                            <v-icon right large class="pl-8">mdi-file-pdf</v-icon>فرم اطلاعات
                        </v-btn>
                    </a>
                </v-row>
              <!--  <v-row class="mt-10 pr-5 pr-sm-3 pr-md-0 pr-lg-0 pr-xl-0">
                    <a href="" class="" style="font-weight:bold;font-size:15px;color:white;cursor:pointer;text-decoration:none;z-index:99"><v-icon color="white">mdi-file-pdf </v-icon>جهت دانلود فایل راهنما کلیک کنید</a>
                    <v-spacer></v-spacer>
                </v-row>-->
            </v-col>
            <v-col></v-col>
            <v-col cols="6" class="hidden-xs-only">
                <v-row class="mt-10">
                    <v-col cols="6"> <v-img :src="downloadphone" max-height="650" max-width="280" class="myanimation"  alt="تعویض روغنی"></v-img></v-col>
                    <v-col cols="6"> <v-img :src="downloadphone1" max-height="650" max-width="280" class="myanimation" alt="تعویض روغنی"></v-img></v-col>
                </v-row>
            </v-col>
        </v-row>
        <br />
        <br />
        <br />
        <v-row class="mt-16" no-gutters id="preview">
            <v-row no-gutters>
                <v-col cols="12" sm="12" md="2" lg="2" xl="2">
                    <v-row>
                        <h1 class="mr-10">آساسرویس در یک نگاه</h1>
                    </v-row>
                    <v-row>
                        <v-col cols="1" sm="10" md="2" lg="2" xl="2"></v-col>
                        <v-col cols="8">
                            <v-progress-linear ress-linear color="deep-purple accent-4"
                                               value="100"
                                               rounded                                              
                                               height="6"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <carousel-3d style="height:700px">
                <slide :index="0" style="height:640px">
                    <img :src="review1"  alt="آساسرویس"/>
                </slide>
                <slide :index="1" style="height:640px">
                    <img :src="review2"  alt="آساسرویس"/>
                </slide>
                <slide :index="2" style="height:640px">
                    <img :src="review3"  alt="آساسرویس"/>
                </slide>
                <slide :index="3" style="height:640px">
                    <img :src="review4"  alt="آساسرویس"/>
                </slide>
                <slide :index="4" style="height:640px">
                    <img :src="review5"  alt="آساسرویس"/>
                </slide>
            </carousel-3d>
        </v-row>
        <v-footer class="mt-16 fotter-style">
            <v-row class="mt-15">
                <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                    <v-row no-gutters>
                        <v-img contain :src="company" max-height="80" max-width="80" alt="آسا سرویس"></v-img>
                        <h2 style="color:white;font-family:'A.RaiMediaBlack_p30download.com';font-size:35px" class="pt-4 pr-5">آسمان کارمانیا</h2>
                    </v-row>
                    <h4 style="color:white" class="mt-4">شرکت دانش بنیان فناوری الکترونیک آسمان کارمانیا ارائه دهنده خدمات نرم افزاری و سخت افزاری با بالاترین کیفیت</h4>
                    <br />
                    <v-row class="pt-3">
                        <v-col cols="6">
                            <img referrerpolicy='origin' id='rgvjwlaowlaojzpefukzjxlz' style='cursor:pointer' onclick='window.open("https://logo.samandehi.ir/Verify.aspx?id=344761&p=xlaoaodsaodsjyoegvkarfth", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")' alt='logo-samandehi' src='https://logo.samandehi.ir/logo.aspx?id=344761&p=qftishwlshwlyndtwlbqnbpd' />
                        </v-col>
                        <v-col cols="6">
                            <a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=188606&amp;Code=v9G12g8pm5GaYm9IytvH"><img referrerpolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=188606&amp;Code=v9G12g8pm5GaYm9IytvH" alt="" style="cursor:pointer" id="v9G12g8pm5GaYm9IytvH"></a>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                    <h2 style="color:white">محصولات</h2>
                    <v-row class="pt-3">
                        <v-col cols="8">
                            <v-divider class="mr-0 pr-0" inset color="#6F45E5"></v-divider>
                        </v-col>
                    </v-row>
                    <v-row class="pr-6" style="color:white">
                        <v-img contain :src="asabyarLogo"  max-height="40" max-width="40" alt="آسا سرویس"></v-img>
                        <h4 class="pt-2 pr-3">آسابیار</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <v-img contain :src="asayabLogo" max-height="40" max-width="40" alt="آسا سرویس"></v-img>
                        <h4 class="pt-2 pr-3">آسایاب</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <v-img contain :src="asayarLogo" max-height="40" max-width="40" alt="آسا سرویس"></v-img>
                        <h4 class="pt-2 pr-3">آسایار</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <v-img contain :src="jobcareLogo" max-height="40" max-width="40" alt="آسا سرویس"></v-img>
                        <h4  class="pt-2 pr-3">کسب و کار</h4>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                    <h2 style="color:white">لینک های مفید</h2>
                    <v-row class="pt-3">
                        <v-col cols="8">
                            <v-divider class="mr-0 pr-0" inset color="#6F45E5"></v-divider>
                        </v-col>
                    </v-row>
                    <v-row class="pr-6" style="color:white">
                        <a href="http://asemantech.com" class="pt-2" style="color:white;text-decoration:none;font-weight:bold">آسمان کارمانیا</a>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <a href="http://asayab.com" class="pt-5" style="color:white;text-decoration:none;font-weight:bold">آسایاب</a>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <a href="http://karmaniatech.com" class="pt-5"  style="color:white;text-decoration:none;font-weight:bold">فناوری کارمانیا</a>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <a href="http://asaserviceapp.com/rule" class="pt-5" style="color:white;text-decoration:none;font-weight:bold">قوانین و مقررات</a>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                    <h2 style="color:white">ارتباط</h2>
                    <v-row class="pt-3">
                        <v-col cols="8">
                            <v-divider class="mr-0 pr-0" inset color="#6F45E5"></v-divider>
                        </v-col>
                    </v-row>
                    <v-row class="pr-6" style="color:white">
                        <h4 class="pt-1"><v-icon color="white">mdi-home</v-icon> کرمان - خیابان میرزاآقاخان شمالی - خیابان رازی - پلاک148</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <h4 class="pt-4"><v-icon color="white">mdi-email</v-icon> fanavari.electronic@gmail.com</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <h4 class="pt-4"><v-icon color="white">mdi-phone mdi-rotate-270</v-icon> 09364444263</h4>
                    </v-row>
                    <v-row class="pr-6 mt-8" style="color:white">
                        <h4 class="pt-2"><v-icon color="white">mdi-fax</v-icon> 32265804</h4>
                    </v-row>
                </v-col>
                <v-col cols="12" class="mx-0 px-0">
                    <v-divider style="background-color:#6F45E5"></v-divider>
                </v-col>
                <v-col cols="12" class="mb-3">
                    <v-row>
                        <v-spacer></v-spacer>
                        <a href="https://telegram.me/fanavarielectronic1399" style="text-decoration:none">
                            <v-btn color="#3B5998" class="ml-3 ml-sm-3 ml-md-6 ml-lg-6 ml-xl-6"
                                   fab
                                   dark>
                                <v-icon large>mdi-send</v-icon>
                            </v-btn>
                        </a>
                        <a href="https://wa.me/09368888265" style="text-decoration:none">
                            <v-btn color="#55ACEE" class="ml-3 ml-sm-3 ml-md-6 ml-lg-6 ml-xl-6"
                                   fab
                                   dark>
                                <v-icon large>mdi-whatsapp</v-icon>
                            </v-btn>
                        </a>
                        <v-btn color="#D24736" class="ml-3 ml-sm-3 ml-md-6 ml-lg-6 ml-xl-6"
                               fab
                               dark>
                            <v-icon large>mdi-google-plus </v-icon>
                        </v-btn>
                        <v-btn color="#007CC1" class="ml-3 ml-sm-3 ml-md-6 ml-lg-6 ml-xl-6"
                               fab
                               dark>
                            <v-icon large>mdi-linkedin</v-icon>
                        </v-btn>
                        <a href="https://www.instagram.com/asaserviceapp/" style="text-decoration:none">
                            <v-btn color="#EC4A89" class="ml-3 ml-sm-3 ml-md-6 ml-lg-6 ml-xl-6"
                                   fab
                                   dark>
                                <v-icon large>mdi-instagram</v-icon>
                            </v-btn>
                        </a>
                        <v-spacer></v-spacer>
                    </v-row>
                </v-col>
                <v-col class="text-center second-footer"
                       cols="12">
                    <v-icon style="color:#87867A">mdi-copyright</v-icon><span style="color:#87867A" class="ml-3">{{ new Date().getFullYear() }}</span> <strong style="color:#FFFFFF">کلیه حقوق برای آسمان کارمانیا محفوظ است</strong>
                </v-col>
            </v-row>
        </v-footer>
    </div>
</template>

<script>
    import 'animate.css';
    import { Carousel3d, Slide } from 'vue-carousel-3d';
    export default {
        name: 'MainPage',
        //title: "آساسرویس",
        components: {
            Carousel3d,
            Slide
        },
        metaInfo: {
            title: 'آساسرویس',
            titleTemplate: '%s | اپلیکیشن جامع مدیریت مراکز تعویض روغن',
            htmlAttrs: {
                lang: 'fa'
            },
            meta: [
                { charset: 'utf-8' },
                { name: 'آساسرویس', content: 'آساسرویس' },
                { name: 'آساسرویس', property:"og:url", content: 'https://www.instagram.com/asaserviceapp/' },
                { name: 'تعویض روغن', property:"og:url", content: 'https://www.instagram.com/asaserviceapp/' },
                { name: 'تعویض روغنی', property:"og:url", content: 'https://www.instagram.com/asaserviceapp/' },
                { name: 'آسا سرویس', content: 'آسا سرویس' },
                { name: 'تعویض روغن', content: 'آسا سرویس' },
                { name: 'برنامه تعویض روغن', content: 'آسا سرویس' },
                { name: 'برنامه تعویض روغن', property:"og:url", content: 'https://www.instagram.com/asaserviceapp/' },
                { name: 'برنامه تعویض روغنی', property:"og:url", content: 'https://www.instagram.com/asaserviceapp/' },
                { name: 'آسا سرویس', content: 'تعویض روغن' },
                { name: 'آسا سرویس', content: 'تعویض روغنی' },
                { name: 'آسا سرویس', content: 'برنامه تعویض روغن اندروید' },
                { name: 'آسا سرویس', content: 'برنامه تعویض روغن ایفون' },
                { name: 'آسا سرویس', content: 'برنامه تعویض روغن آیفون' },
                { name: 'آسا سرویس', content: 'برنامه اتوسرویس' },
                { name: 'آسا سرویس', content: 'برنامه اتو سرویس' },
                { name: 'آسا سرویس', content: 'نرم افزار اتو سرویس' },
                { name: 'آسا سرویس', content: 'نرم افزار اتو سرویس اندروید' },
                { name: 'آسا سرویس', content: 'نرم افزار اتو سرویس ایفون' },
                { name: 'آسا سرویس', content: 'نرم افزار اتو سرویس آیفون' },
                { name: 'آساسرویس', content: 'نرم افزار آساسرویس' },
                { name: 'آساسرویس', content: 'نرم افزار آسا' },
                { name: 'آساسرویس', content: 'اپلیکیش آسا' },
                { name: 'آسا سرویس', content: 'اپلیکیش آسا' },
                { name: 'آسا سرویس', content: 'نرم افزار آسا' },
                { name: 'آسا سرویس', content: 'نرم افزار آسا سرویس' },
                { name: 'آساسرویس', content: 'اپلیکیشن آساسرویس' },
                { name: 'آسا سرویس', content: 'اپلیکیشن آسا سرویس' },
                { name: 'آسا سرویس', content: 'اپلیکیشن تعویض روغن' },
                { name: 'آساسرویس', content: 'اپلیکیشن تعویض روغن' },
                { name: 'آسا سرویس', content: 'نرم افزار تعویض روغن' },
                { name: 'آساسرویس', content: 'نرم افزار تعویض روغن' },
                { name: 'آساسرویس', content: 'نرم افزار تعویض روغن اندروید' },
                { name: 'آسا سرویس', content: 'نرم افزار تعویض روغن اندروید' },
                { name: 'آساسرویس', content: 'اپلیکیشن تعویض روغن اندروید' },
                { name: 'آسا سرویس', content: 'اپلیکیشن تعویض روغن اندروید' },
                { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
        },
        data() {
            return {
                test: "",
                exp: 1,
                exp2: 1,
                exp3: 1,
                exp4: 1,
                sidebar: false,
                menuItems: [{ title: "معرفی" }, { title: "مزیت ها" }, { title: "امکانات ویژه" }, { title: "پیشنهاد ویژه" }, { title: "دانلود نرم افزار" }, { title: "پیش نمایش" }],
                fab: false,
                group: null,
                }
        },
        watch: {
            group() {
                this.sidebar = false
            },
        },
        methods: {
            appStore: function () {
                window.location.href = "https://pwapanel.asaserviceapp.com/#/";
            },
            expanClick: function () {
                if (this.exp == 0) {
                    //document.getElementById("expan").style.backgroundColor = "white";
                    document.getElementById("expan").style.backgroundImage = 'linear-gradient(to right, white, white)';
                    document.getElementById("expheader").style.color = '#8B8B99';
                    document.getElementById("expheadericon").style.color = '#7DDDE9';
                } else if (this.exp == undefined || this.exp == "" || this.exp==1) {
                    document.getElementById("expan").style.backgroundImage = 'linear-gradient(to right, #0052d4, #4364f7, #6fb1fc)';
                    document.getElementById("expheader").style.color = 'white';
                    document.getElementById("expheadericon").style.color = 'white';
                }               
            },
            expan2Click: function () {
                if (this.exp2 == 0) {
                    document.getElementById("expan2").style.backgroundImage = 'linear-gradient(to right, white, white)';
                    document.getElementById("expheader2").style.color = '#8B8B99';
                    document.getElementById("expheadericon2").style.color = '#7DDDE9';
                } else if (this.exp2 == undefined || this.exp2 == "" || this.exp2==1) {
                    document.getElementById("expan2").style.backgroundImage = 'linear-gradient(to right, #0052d4, #4364f7, #6fb1fc)';
                    document.getElementById("expheader2").style.color = 'white';
                    document.getElementById("expheadericon2").style.color = 'white';
                }               
            },
            expan3Click: function () {
                if (this.exp3 == 0) {
                    document.getElementById("expan3").style.backgroundImage = 'linear-gradient(to right, white, white)';
                    document.getElementById("expheader3").style.color = '#8B8B99';
                    document.getElementById("expheadericon3").style.color = '#7DDDE9';
                } else if (this.exp3 == undefined || this.exp3 == "" || this.exp3==1) {
                    document.getElementById("expan3").style.backgroundImage = 'linear-gradient(to right, #0052d4, #4364f7, #6fb1fc)';
                    document.getElementById("expheader3").style.color = 'white';
                    document.getElementById("expheadericon3").style.color = 'white';
                }               
            },
            expan4Click: function () {
                if (this.exp4 == 0) {
                    document.getElementById("expan4").style.backgroundImage = 'linear-gradient(to right, white, white)';
                    document.getElementById("expheader4").style.color = '#8B8B99';
                    document.getElementById("expheadericon4").style.color = '#7DDDE9';
                } else if (this.exp4 == undefined || this.exp4 == "" || this.exp4==1) {
                    document.getElementById("expan4").style.backgroundImage = 'linear-gradient(to right, #0052d4, #4364f7, #6fb1fc)';
                    document.getElementById("expheader4").style.color = 'white';
                    document.getElementById("expheadericon4").style.color = 'white';
                }               
            },
            onScroll(e) {
                if (typeof window === 'undefined') return
                const top = window.pageYOffset || e.target.scrollTop || 0
                this.fab = top > 20
            },
            toTop() {
                this.$vuetify.goTo(0)
            },
            openSidebar: function () {
                if (this.sidebar) {
                    this.sidebar = false
                } else {
                    this.sidebar = true;
                }
            },
            openAsaService: function () {
                window.open("https://asaapp.asaserviceapp.com/");
            }
        },
        computed: {
            getLogo() {
                return this.$store.state.generalModule.logo;
            },
            phone() {
                return this.$store.state.generalModule.phone;
            },
            phone2() {
                return this.$store.state.generalModule.phone2;
            },
            phone1() {
                return this.$store.state.generalModule.phone1;
            },
            phone11() {
                return this.$store.state.generalModule.phone11;
            },
            dashlaptop() {
                return this.$store.state.generalModule.dashlaptop;
            },
            phonedownalod() {
                return this.$store.state.generalModule.phonedownalod;
            },
            phonedownalod2() {
                return this.$store.state.generalModule.phonedownalod2;
            },
            dash1() {
                return this.$store.state.generalModule.dash1;
            },
            dash2() {
                return this.$store.state.generalModule.dash2;
            },
            dash3() {
                return this.$store.state.generalModule.dash3;
            },
            dash4() {
                return this.$store.state.generalModule.dash4;
            },
            background1() {
                return this.$store.state.generalModule.background1;
            },
            downloadphone() {
                return this.$store.state.generalModule.downloadphone;
            },
            downloadphone1() {
                return this.$store.state.generalModule.downloadphone1;
            },
            background2() {
                return this.$store.state.generalModule.background2;
            },
            price1() {
                return this.$store.state.generalModule.price1;
            },
            price2() {
                return this.$store.state.generalModule.price2;
            },
            shap() {
                return this.$store.state.generalModule.shap;
            },
            review1() {
                return this.$store.state.generalModule.review1;
            },
            review2() {
                return this.$store.state.generalModule.review2;
            },
            review3() {
                return this.$store.state.generalModule.review3;
            },
            review4() {
                return this.$store.state.generalModule.review4;
            },
            review5() {
                return this.$store.state.generalModule.review5;
            },
            asabyarLogo() {
                return this.$store.state.generalModule.asabyarLogo;
            },
            asayabLogo() {
                return this.$store.state.generalModule.asayabLogo;
            },
            jobcareLogo() {
                return this.$store.state.generalModule.jobcareLogo;
            },
            asayarLogo() {
                return this.$store.state.generalModule.asayarLogo;
            },
            company() {
                return this.$store.state.generalModule.company;
            },
        }
    };
</script>

<style scoped>
    .myanimation {
        animation-name: example;
        animation-duration: 3s;
        animation-iteration-count: infinite;
    }

    @keyframes example {
        0% {
            
        }
        50% {
            transition: transform 3s linear;
            transform: translateY(-10px);
        }
        98% {
            transition: transform 3s linear;
            transform: translateY(10px);   
        }
    }
    .btnanimation {
        color:darkblue;
        background: linear-gradient(to right, darkblue 50%, white 50%);
        background-size: 200% 100%;
        background-position: right bottom;
        transition: all .5s ease-out;
    }
        .btnanimation:hover {
            background-position: left bottom;
            color:white
        }
    .maindownloadbtn {
        color: white;
        background: linear-gradient(to right, white 50%, darkblue 50%);
        background-size: 200% 100%;
        background-position: right bottom;
        transition: all .5s ease-out;
    }
        .maindownloadbtn:hover {
            background-position: left bottom;
            color: darkblue
        }


.cardanimation {
        color:darkblue;
        background: linear-gradient(to right, darkblue 50%, white 50%);
        background-size: 200% 100%;
        background-position: right bottom;
        transition: all .5s ease-out;
}
            .cardanimation:hover {
                background-position: left bottom;
                color: white
            }
    .cardtext {
        color: #7B7B7B;
    }
    .cardanimation:hover .cardtext {
        color: white
    }
              


    .btnanimationicon{
        color:darkblue
    }
    .btnanimationicon:hover {
        color: white
    }
    .cardbtn {
        animation-name: cardbtnanim;
        animation-duration: 5s;
        animation-iteration-count: infinite;
    }

    @keyframes cardbtnanim {
        0% {
        }

        50% {
            -webkit-transform: scale(1.2);
            -ms-transform: scale(1.2);
            transform: scale(1.2);
        }
    }

    .price_icon {
        width: 200px;
        height: 200px;
        border-radius: 50%;
        background-color: rgba(3, 218, 246, 0.051);
        display: inline-block;
        position: relative;
        line-height: 200px;
        margin-top: 24px;
    }
    .pricecard {
        background-color: #FCFCFF;
    }
    .pricecard:hover{
        background-color:white
    }
    .pricecardicon {
        animation-name: pricecardiconanim;
        animation-duration: 5s;
        animation-iteration-count: infinite;
    }

    @keyframes pricecardiconanim {
        0% {
        }

        50% {
            -webkit-transform: scale(1.1);
            -ms-transform: scale(1.1);
            transform: scale(1.1);
        }
    }

    .shap {
        position: absolute;
        width: 1280px;
        height:450px;
        left: 0;
        bottom: 0;
        background-repeat: no-repeat;
    }


    .downloadbtn {
        color: white;
        background: linear-gradient(to right, white 50%, darkblue 50%);
        background-size: 200% 100%;
        background-position: right bottom;
        transition: all .5s ease-out;
    }

        .downloadbtn:hover {
            background-position: left bottom;
            color: darkblue
        }
    .downloadbtn2 {
        color: white;
        background: linear-gradient(to right, white 50%, darkblue 50%);
        background-size: 200% 100%;
        background-position: right bottom;
        transition: all .5s ease-out;
    }

        .downloadbtn2:hover {
            background-position: left bottom;
            color: darkblue
        }

    .floatingAnimation {
        animation-name: floatanim;
        animation-duration: 3s;
        animation-iteration-count: 1;
        left:2%
    }

    @keyframes floatanim {
        0% {
            top:0
        }

        100%{
            top:90%
        }
    }
    .floatingAnimationreverse {
        animation-name: floatanimreverse;
        animation-duration: 3s;
        animation-iteration-count: 1;
        left: 2%
    }

    @keyframes floatanimreverse {
        0% {
            top: 98%
        }

        100% {
            top: 0%
        }
    }

    .asaservicetext {
        color: white;
        font-family: 'Yekan-Bakh-Regular';
        font-size: 25px
    }
    @media screen and (max-width: 600px) {
        .asaservicetext {
            font-size: 15px;
            color: white;
            font-family: 'Yekan-Bakh-Regular';
        } 
    }

    .fotter-style {
        background-image: linear-gradient( 0deg,#2b3b72,rgba(43,59,114,0.9));
        bottom:0;
        border-top-left-radius:150px;
    }
    .second-footer {
        background-color: rgba(96,160,231,0.29);
        bottom:0;
        right:0;
        left:0;
    }
</style>